// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k2-z","displaySixCardTiles":"l2-z"};